import {
  Box,
  LinearProgress,
  Modal,
  Paper,
  Typography,
} from "@material-ui/core";
import { useTheme, makeStyles } from "@material-ui/core/styles";
import * as React from "react";

const useStyles = makeStyles((theme: any) => ({
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "310.25px",
    height: "226px",
    outline: "none",
    padding: "24px",
  },
  contentBox: {
    width: "fit-content",
    paddingLeft: "24px",
    paddingRight: "24px",
  },
  progressBox: {
    marginTop: "16px",
  },
  progressBar: {
    borderRadius: "4px",
    backgroundColor: theme.custom.styles.linearProgressBarStyle.secondaryBarColor,
    "& .MuiLinearProgress-bar": {
      backgroundColor: theme.custom.styles.linearProgressBarStyle.primaryBarColor,
    },
  },
}));

interface ModalLinearActivityIndicatorProps {
  headerText?: string;
  descriptionText?: string;
}

const ModalLinearActivityIndicator = (
  props: ModalLinearActivityIndicatorProps,
) => {
  const [open] = React.useState(true);
  const theme: any = useTheme();
  const classes = useStyles();
  const {
    headerText = "Loading",
    descriptionText = "Please wait, this may take a moment",
  } = props;

  return (
    <Modal
      className={classes.modal}
      BackdropProps={{
        style: {
          backgroundColor: "#f7f8facc",
        },
      }}
      open={open}
    >
      <Paper
        elevation={3}
        className={classes.paper}
        style={{
          borderRadius: theme.custom.styles.linearProgressBarStyle.borderRadius,
        }}
      >
        <Typography style={theme.custom.styles.linearProgressBarStyle.header}>
          {headerText}
        </Typography>

        <Box className={classes.contentBox}>
          <Typography
            style={theme.custom.styles.linearProgressBarStyle.description}
          >
            {descriptionText}
          </Typography>

          <Box className={classes.progressBox}>
            <LinearProgress className={classes.progressBar} />
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
};

export default ModalLinearActivityIndicator;
